import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GenerateReportService {

  constructor() {}

  public descargar(tipo: number, base64: string, nombre: string){
    if(tipo === 1){
      this.descargarPDF(base64, nombre);
      return;
    }

    if(tipo === 2){
      this.descargarExcel(base64, nombre);
      return;
    }
  }

  private descargarPDF(base64: string, nombre: string) {
    const downloadLink = document.createElement('a');
    downloadLink.href = 'data:application/pdf;base64,' + base64;
    downloadLink.download = nombre;
    downloadLink.click();
  }

  private descargarExcel(base64: string, nombre: string) {
    const downloadLink = document.createElement('a');
    downloadLink.href = 'data:application/vnd.ms-excel;base64,' + base64;
    downloadLink.download = nombre;
    downloadLink.click();
  }
}

// INVESTIGAR
// Hay un formato Excel mucho mas moderno: vnd.openxmlformats-officedocument.spreadsheetml.sheet
// Lo intente usar, pero el archivo que se genera aparece como dañado
// Quizas se trate de un error al momento de general el Crystal Report.
